<template>
  <v-autocomplete
    v-model="selected"
    :items.sync="items"
    item-text="key"
    item-value="key"
    :label="label"
    :clearable="clearable"
    hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {CurrencyGroupModel} from "@/modules/redactor/models/currency/CurrencyGroupModel";

export default {
  name: "r-currency-group-dropdown",

  props: {
    model: VueTypes.instanceOf(CurrencyGroupModel),
    label: VueTypes.string.def("Currency Group"),
    clearable: VueTypes.bool.def(false)
  },

  data() {
    return {
      items: [],
      selected: null
    };
  },

  watch: {
    model: {
      handler(newVal) {
        const key = newVal?.key ?? CurrencyGroupModel.getNone(this.items)?.key ?? null;
        this.selected = key;

        if (!newVal && key) {
          const obj = this.items.find(item => item.key === key);
          this.$emit("update:model", obj);
        }
      },

      immediate: true
    },

    selected(newKey) {
      const selObj = this.items.find(item => item.key === newKey) || null;

      this.$emit("update:model", selObj);
    },

    items: {
      handler() {
        if (!this.selected && (!this.model || !this.model.key)) {
          const none = CurrencyGroupModel.getNone(this.items);
          if (none) {
            this.selected = none.key;
            this.$emit("update:model", none);
          }
        }
      },

      immediate: true
    }
  },

  created() {
    this.items = RedactorUtils.getCurrencyGroups();
  },
}
</script>